import React from 'react';
import ForgotPassword from 'components/ForgotPassword';
import useInstanceConfig from 'modules/siteConfig/hooks/useInstanceConfig';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import getStaticPathsSite from 'utils/getStaticPathsSite';

export default function ForgotPasswordPage() {
  const { site } = useInstanceConfig();
  const title = 'Forgot Password';
  const url = `https://${site.host}/forgot-password`;
  const { siteName } = site.seo;
  const description = `Forgot Password Page for ${siteName}`;

  return (
    <>
      <ForgotPassword />
      <NextSeo
        canonical={url}
        description={description}
        openGraph={{
          title,
          description,
          site_name: siteName,
          type: 'website',
        }}
        title={title}
        twitter={{
          site: site.seo.twitterHandle,
          cardType: 'summary_large_image',
        }}
      />
    </>
  );
}

export { getStaticPathsSite as getStaticPaths };

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {},
    revalidate: 180,
  };
};
